(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-bento-tecnologia"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var cells = document.querySelectorAll('.mt-bento [data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-in-view');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      cells.forEach(function(c) { io.observe(c); });
    } else {
      cells.forEach(function(c) { c.classList.add('mt-in-view'); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-conversion-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btns = document.querySelectorAll('.mt-close [data-magnetic]');
    btns.forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.25) + 'px,' + (y * 0.35) + 'px)';
      });
      btn.addEventListener('mouseleave', function() { btn.style.transform = 'translate(0,0)'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-hero-premium"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btns = document.querySelectorAll('.mt-hero [data-magnetic]');
    btns.forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.25) + 'px,' + (y * 0.35) + 'px)';
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.transform = 'translate(0,0)';
      });
    });

    var carousels = document.querySelectorAll('.mt-hero [data-carousel]');
    carousels.forEach(function(carousel) {
      var wrap = carousel.closest('.mt-hero__carousel-wrap');
      var slides = carousel.querySelectorAll('.mt-hero__slide');
      var dotsWrap = wrap.querySelector('[data-carousel-dots]');
      var dots = dotsWrap ? dotsWrap.querySelectorAll('button') : [];

      function setActive(idx) {
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
      }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var idx = Array.prototype.indexOf.call(slides, entry.target);
              setActive(idx);
            }
          });
        }, { root: carousel, threshold: 0.6 });
        slides.forEach(function(s) { io.observe(s); });
      }

      var prevBtn = wrap.querySelector('[data-carousel-prev]');
      var nextBtn = wrap.querySelector('[data-carousel-next]');
      if (prevBtn) prevBtn.addEventListener('click', function() { carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function() { carousel.scrollBy({ left: carousel.clientWidth, behavior: 'smooth' }); });

      var isDown = false, startX = 0, startScroll = 0;
      carousel.addEventListener('mousedown', function(e) {
        isDown = true;
        carousel.classList.add('is-dragging');
        startX = e.pageX;
        startScroll = carousel.scrollLeft;
      });
      window.addEventListener('mouseup', function() {
        isDown = false;
        carousel.classList.remove('is-dragging');
      });
      window.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var walk = e.pageX - startX;
        carousel.scrollLeft = startScroll - walk;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-testimonios-editorial"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var cards = document.querySelectorAll('.mt-press [data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-in-view');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      cards.forEach(function(c) { io.observe(c); });
    } else {
      cards.forEach(function(c) { c.classList.add('mt-in-view'); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
